export default __webpack_public_path__ + "static/media/FourthImageModel.d4060216.png";